import { render } from "./ViewInvoice.vue?vue&type=template&id=04ff5bca&scoped=true"
import script from "./ViewInvoice.vue?vue&type=script&lang=js"
export * from "./ViewInvoice.vue?vue&type=script&lang=js"

import "./ViewInvoice.vue?vue&type=style&index=0&id=04ff5bca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-04ff5bca"

export default script